import useDraftUpdatePipelineStage from '@/ui/pages/pipelineConfigPage/api/mutations/useDraftUpdatePipelineStage';
import { Input } from '@payaca/ambrosia';
import { MAX_PIPELINE_STAGE_TITLE_LENGTH } from '@payaca/constants/pipeline';
import { FC, useEffect, useState } from 'react';

type Props = {
  stagePublicId: string;
  pipelineId: string;
  title: string;
};

const PipelineStageTitleInput: FC<Props> = ({
  stagePublicId,
  pipelineId,
  title,
}) => {
  const [localTitle, setLocalTitle] = useState(title);

  useEffect(() => {
    setLocalTitle(title);
  }, [title]);

  const { mutate: updateStage } = useDraftUpdatePipelineStage({
    pipelineId,
  });

  return (
    <>
      <label className="sr-only" htmlFor={`${stagePublicId}-stage-name`}>
        Pipeline stage name
      </label>
      <Input
        id={`${stagePublicId}-stage-name`}
        className="w-full"
        sizeVariant="sm"
        value={localTitle}
        onChange={setLocalTitle}
        maxLength={MAX_PIPELINE_STAGE_TITLE_LENGTH}
        changeTimeoutMs={500}
        onChangeTimeout={(value) => {
          if (value.trim() === '') return;
          updateStage({ id: stagePublicId, title: value });
        }}
        onBlur={() => {
          if (localTitle.trim() === '') {
            setLocalTitle(title);
          }
        }}
      />
    </>
  );
};

export default PipelineStageTitleInput;
